import { Link as RouterLink } from 'react-router-dom';
import { Text, TextLink } from 'components/ui';
import type { AuthFooterPromptProps } from './AuthFooterPrompt.props';

const AuthFooterPrompt = ({
  disabled = false,
  linkLabel,
  linkSuffix,
  prompt,
  replace = false,
  to,
}: AuthFooterPromptProps) => (
  <Text
    sx={{
      color: 'primary.dark',
      fontSize: 16,
      lineHeight: 1.45,
    }}
    textAlign="center"
    variant="body2"
  >
    {prompt}{' '}
    <TextLink<typeof RouterLink>
      component={RouterLink}
      disabled={disabled}
      replace={replace}
      to={to}
      variant="body2"
      visualVariant="anchor"
    >
      {linkLabel}
      {linkSuffix ? <> {linkSuffix}</> : null}
    </TextLink>
  </Text>
);

export default AuthFooterPrompt;
